<template>
  <section class="left-container">
      <div class="left-content clearfix">
        <div class="mrg-btm-15 clearfix">
          <!-- <dl>
            <dt>自营规则<i class="iconfont icon-rule-arrow-up"></i><i class="iconfont icon-rule-arrow-down"></i><i class="iconfont icon-rule-arrowdown"></i><i class="iconfont icon-rule-arrow-up-bold"></i></dt>
            <dd>招商管理</dd>
            <dd>运营管理</dd>
            <dd>商品管理</dd>
          </dl> -->
          <dl v-for="(item, index) in navList" :key="'1-' + index">
            <dt :class="{'active': item.isOpen, 'highlight': item.isOpen && (!item.children || !item.children.length)}" @click="select(item)">
              {{item.name}}
              <i class="iconfont" :class="{'icon-rule-arrow-down': !item.isOpen, 'icon-rule-arrow-up': item.isOpen}" v-if="item.children && item.children.length" @click.stop="toggle(item)"></i>
            </dt>
            <dd :class="{'active': item.isOpen}" v-if="item.children && item.children.length && item.isOpen">
              <ListTree v-for="(item2, index2) in item.children" :key="'2-' + index2" :item="item2" :class="{'active': item.isOpen}" @select="select" :open="openIds" @toggle="toggle"></ListTree>
            </dd>
          </dl>
        </div>
      </div>

  </section>
</template>

<script>
import ListTree from './listTree.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: '',
  data () {
    return {
    }
  },
  computed: {
    ...mapState('rule', {
      page: 'page',
      navList: 'leftNavList',
      openIds: 'openIds'
    }),
    ...mapState({
      categoryId: 'categoryId',
      childCategoryId: 'childCategoryId'
    })
  },
  async mounted () {
    this.mountedFn()
  },
  beforeUnmount () {
    this.$store.commit('updateCategoryId', {
      categoryId: '',
      childCategoryId: ''
    })
    this.$store.commit('rule/updateNoticeList', {
      noticeList: []
    })
  },
  methods: {
    async mountedFn() {
      this.updatePage(this.$route.name)
      let categoryId = await this.getNoticeRootCategoryId()
      const {
        childCategoryId
      } = this.$route.query
      if (this.$route.query.categoryId) {
        categoryId = this.$route.query.categoryId
      }
      this.$store.commit('updateCategoryId', {
        categoryId,
        childCategoryId: childCategoryId || categoryId
      })
      this.refreshFn()
      await this.getChildren()
      this.setOpenIds()
      this.$emit('loadData')
    },
    async loadData () {
      return this.getChildren()
    },
    ...mapActions('rule', ['getChildren', 'setOpenIds', 'getNoticeRootCategoryId']),
    ...mapMutations('rule', ['updateOpenIds', 'refreshFn', 'updatePage']),
    select (item) {
      // console.log(233, this.categoryId, item, this.openIds === item.ids, item.ids, this.openIds, this, this.$set)
      if ((!item.children || !item.children.length) && item.isOpen) {
        return
      }
      if (this.openIds === item.ids || (item.children && item.children.length)) {
        item.isOpen = !item.isOpen
        return
      }
      this.$router.push({
        name: this.page,
        query: {
          categoryId: this.categoryId,
          childCategoryId: item.categoryId
        }
      })
      this.$store.commit('updateCategoryId', {
        categoryId: this.categoryId,
        childCategoryId: item.categoryId
      })
      this.updateOpenIds({
        openIds: item.ids
      })
    },
    setIds (defaultIds = [], item) {
      item.ids = [].concat(defaultIds)
      item.ids.push(item.categoryId)
      if (item.children) {
        item.children.forEach((item2) => {
          this.setIds(item.ids, item2)
        })
      }
    },
    toggle (item) {
      item.isOpen = !item.isOpen
    }
  },
  watch: {
    $route (newVal, oldVal) {
      if (newVal !== oldVal && (newVal.name === 'Rule' || newVal.name === 'Notice')) {
        this.mountedFn()
      }
    },
    categoryId (newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.$emit('loadData')
      }
    },
    childCategoryId (newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.$emit('loadData')
      }
    }
  },
  components: {
    ListTree
  }
}
</script>

<style lang="scss" scoped>
.left-container {
  background: #fff;
  float: left;
  width: 238px;
  position: absolute;
  overflow: auto;
  height: 100%;
  .left-content {
    margin-top: 15px;
    dl {
      dt {
        font-family: \5FAE\8F6F\96C5\9ED1,sans-serif;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        position: relative;
        padding-left: 20px;
        line-height: 36px;
        cursor: pointer;
        i {
          position: absolute;
          right: 20px;
          top: 12px;
          line-height: 18px;
          font-weight: bold;
        }
        &.active {
          color: #333;
          font-weight: 400;
        }
        &.highlight {
          background: #F1F1F3;
          border-left: 4px solid #F10180;
        }
      }
      dd{
        cursor: pointer;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        line-height: 40px;
        display: none;
        // border-left: 4px solid #F10180;
        &.active {
          display: block;
          color: #333;
        }
      }
    }
  }
}

</style>
